import axios from 'axios';
import moment from 'moment';

export default {
	namespaced: true,
	state: {
		query: {
			days: 31,
		},
		jobs: [],
		topPosters: [],
		topWorkers: [],
	},
	getters: {
		dashboardJobs: (state) => state.jobs,
		topPosters: (state) => state.topPosters,
		topWorkers: (state) => state.topWorkers,
		queryDays: (state) => state.query.days,
	},
	mutations: {
		SET_JOB_SUMMARY: (state, jobs) => { state.jobs = jobs; },
		SET_TOP_POSTERS: (state, topPosters) => { state.topPosters = topPosters; },
		SET_TOP_WORKERS: (state, topWorkers) => { state.topWorkers = topWorkers; },
		SET_DAYS_QUERY: (state, days) => { state.query.days = days; },
	},
	actions: {
		loadJobSummary: async ({ commit, state, rootState }) => {
			const url = '/api/v1/jobs/postingsperday';
			const results = await axios.get(
				url,
				{ params: state.query, headers: { Authorization: rootState.token } },
			);

			const mapHashArray = (arr) => {
				const hash = {};
				arr.forEach((item) => {
					hash[moment(item.date).format('YYYY-MM-DD')] = item;
				});
				return hash;
			};

			const jobHash = mapHashArray(results.data, 'date');
			const paddedJobs = [];
			const { days } = state.query;
			const day = moment().add(-days, 'day');

			for (let d = 0; d < days; d += 1) {
				const dateIndex = day.format('YYYY-MM-DD');
				// do I have some data for this day?
				if (jobHash[dateIndex]) {
					paddedJobs.push(jobHash[dateIndex]);
				} else {
					paddedJobs.push({
						date: dateIndex,
						count: 0,
						confirmedCount: 0,
					});
				}
				day.add(1, 'day');
			}
			commit('SET_JOB_SUMMARY', paddedJobs);
		},
		loadTopPosters: async ({ commit, state, rootState }) => {
			const url = '/api/v1/jobs/topposters';
			const results = await axios.get(
				url,
				{
					params: state.query,
					headers: { Authorization: rootState.token },
				},
			);
			commit('SET_TOP_POSTERS', results.data);
		},
		loadTopWorkers: async ({ commit, state, rootState }) => {
			const url = '/api/v1/jobs/topworkers';
			const results = await axios.get(url, {
				params: state.query,
				headers: { Authorization: rootState.token },
			});
			commit('SET_TOP_WORKERS', results.data);
		},
		setDaysQuery: ({ commit }, days) => {
			commit('SET_DAYS_QUERY', days);
		},
	},
};
